export default {
  data() {
    return {
      projects: [],
    };
  },
  methods: {
    /**
     * Fetch projects.
     * @returns {Promise<*>}
     */
    async fetchProjects() {
      this.$startLoading('projects');

      // fetch projects
      const projects = await this.$api.projects.index();

      // set projects
      this.projects = projects;

      this.$stopLoading('projects');
      return projects;
    },
    /**
     * Update project.
     * @returns {Promise<void>}
     */
    async updateProject(project, field, oldValue, newValue, added, removed) {
      const { ID: projectId } = project;

      // set project to the new value
      project[field] = newValue;

      try { // save new value
        this.$startLoading(`project-${projectId}-${field}`);
        if (field === 'DepartmentIDs') {
          await this.$api.projects.update(projectId, 'performers', { added, removed });
        } else {
          await this.$api.projects.update(projectId, field, newValue);
        }
        this.$stopLoading(`project-${projectId}-${field}`);
      } catch (err) {
        project[field] = oldValue;
        this.$stopLoading(`project-${projectId}-${field}`);
        throw err;
      }
    },
    /**
     * Calculate project responsible.
     */
    calculateProjectResponsible() {
      this.projects.responsible = Object.keys(
        this.projects
          .map(({ Responsible }) => Responsible)
          .filter(responsible => responsible)
          .reduce((acc, responsible) => ({ ...acc, [responsible]: true }), {}),
      );
    },
  },
  watch: {
    projects: {
      handler: 'calculateProjectResponsible',
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.projects.responsible = [];
  },
};
